import { createStorageAtomFactory } from '@exodus/atoms';
import type { Definition } from '@exodus/dependency-types';

import type { UsedBlinkActions } from '../types.js';

const createBlinkActionsAtom = ({ storage }) =>
  createStorageAtomFactory<UsedBlinkActions>({ storage })({
    key: 'actions',
  });

const blinkActionsAtomDefinition = {
  id: 'blinkActionsAtom',
  type: 'atom',
  factory: createBlinkActionsAtom,
  dependencies: ['storage'],
} as const satisfies Definition;

export type BlinkActionsAtom = ReturnType<
  typeof blinkActionsAtomDefinition.factory
>;

export default blinkActionsAtomDefinition;
